import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CostspriceListComponent } from './components/article-editor/costsprice-list/costsprice-list.component';
import { ErpCommonModule } from './../erp-common/erp-common.module';
import { NumberInputModule, ServiceResponseModule } from '@sdbn/appclient';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogAdminComponent } from './components/catalog-admin/catalog-admin.component';
import { CatalogRoutingModule } from './catalog-routing.module';
import { CatalogMasterdataComponent } from './components/catalog-masterdata/catalog-masterdata.component';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { CommonLayoutModule } from '@sdbn/common';

import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { ArticleEditorComponent } from './components/article-editor/article-editor.component';
import { DescriptionEditorComponent } from './components/article-editor/description-editor/description-editor.component';
import { DictionaryModule } from '@sdbn/appclient';
import { PriceEditorComponent } from './components/article-editor/price-editor/price-editor.component';
import { AddCatalogDialogComponent } from './components/add-catalog-dialog/add-catalog-dialog.component';
import { AddCatalogNodeDialogComponent } from './components/add-catalog-node-dialog/add-catalog-node-dialog.component';
import { AddArticleTypeSelectionComponent } from './components/add-article-type-selection/add-article-type-selection.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ChangeCatalogDialogComponent } from './components/change-catalog-dialog/change-catalog-dialog.component';
import { ChangeCatalogNodeDialogComponent } from './components/change-catalog-node-dialog.component.ts/change-catalog-node-dialog.component';
import { CommonDateModule, CUSTOM_DATE_FORMAT } from '@sdbn/appclient';
import { CatalogArticleSearchComponent } from './components/catalog-article-search/catalog-article-search.component';
import { RetailpriceListComponent } from './components/article-editor/retailprice-list/retailprice-list.component';
import { RetailpriceBasicarticleListComponent } from './components/article-editor/retailprice-basicarticle-list/retailprice-basicarticle-list.component';
import { AttributeValuePipe } from './pipe/attribute-value.pipe';
import { CatalogStructureComponent } from './components/catalog-structure/catalog-structure.component';
import { TmcCustomDateAdapter } from '@sdbn/appclient';
import { importCostsPricesDialogComponent } from './components/import-costsprice-dialog/import-costsprice-dialog.component';



@NgModule({
  declarations: [
    CatalogAdminComponent,
    CatalogMasterdataComponent,
    CatalogStructureComponent,
    ArticleEditorComponent,
    DescriptionEditorComponent,
    PriceEditorComponent,
    AddCatalogDialogComponent,
    AddCatalogNodeDialogComponent,
    AddArticleTypeSelectionComponent,
    ChangeCatalogDialogComponent,
    ChangeCatalogNodeDialogComponent,
    CatalogArticleSearchComponent,
    RetailpriceListComponent,
    RetailpriceBasicarticleListComponent,
    CostspriceListComponent,
    importCostsPricesDialogComponent,
    AttributeValuePipe
  ],
  imports: [
    CommonModule,
    CatalogRoutingModule,
    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIModule,
    MaterialModule,
    ReactiveFormsModule,
    DictionaryModule,
    SharedModule,
    CommonDateModule,
    NumberInputModule,
    ErpCommonModule,
    ServiceResponseModule
  ],
  providers: [
    { provide: DateAdapter, useClass: TmcCustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'de' }
  ]
})
export class CatalogModule { }
